import { ReactNode, ReactPortal, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Platform } from 'react-native';

let mount: HTMLElement | null = null;
let el: HTMLElement | null = null;

if (Platform.OS === 'web' && typeof document !== 'undefined') {
  mount = document.getElementById('portal-root');
  el = document.createElement('div');
}

const Portal = ({ children }: { children?: ReactNode }): ReactPortal => {
  useEffect(() => {
    if (!el) return;

    mount?.appendChild(el);

    return () => {
      if (el) {
        mount?.removeChild(el);
      }
    };
  }, []);

  return createPortal(children, el as HTMLDivElement);
};

export default Portal;
